import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { formatCurrency } from '../../utils/format';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api' });

function calcLayout(n) {
  if (n <= 10) return { useColumns: false, compact: false, itemPad: '12px 16px', nameFz: 20, emojiFz: 28, valFz: 20, gap: 12, radius: 12 };
  if (n <= 20) return { useColumns: true,  compact: false, itemPad: '9px 14px',  nameFz: 17, emojiFz: 24, valFz: 17, gap: 8,  radius: 10 };
  return             { useColumns: true,  compact: true,  itemPad: '6px 12px',  nameFz: 14, emojiFz: 20, valFz: 14, gap: 5,  radius: 8  };
}

function ColHeader() {
  return (
    <div style={{
      display: 'grid', gridTemplateColumns: '1fr auto auto',
      gap: 12, padding: '4px 12px',
      color: 'rgba(255,255,255,0.45)', fontSize: 11, fontWeight: 700,
      textTransform: 'uppercase', letterSpacing: 1, flexShrink: 0,
    }}>
      <span>Item</span>
      <span style={{ textAlign: 'center' }}>Qtd</span>
      <span style={{ textAlign: 'right' }}>Valor</span>
    </div>
  );
}

function ItemRow({ item, layout }) {
  const { itemPad, nameFz, emojiFz, valFz, compact, radius } = layout;
  return (
    <div style={{
      background: 'rgba(255,255,255,0.07)',
      borderRadius: radius,
      padding: itemPad,
      display: 'grid',
      gridTemplateColumns: '1fr auto auto',
      gap: 12,
      alignItems: 'center',
      borderLeft: '3px solid #e63946',
      flexShrink: 0,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
        <span style={{ fontSize: emojiFz, flexShrink: 0 }}>{item.emoji || '🥟'}</span>
        <span style={{
          color: '#fff', fontSize: nameFz, fontWeight: 600,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>{item.nome}</span>
      </div>
      <div style={{
        background: 'rgba(255,255,255,0.1)', borderRadius: 6,
        padding: compact ? '3px 10px' : '4px 12px',
        color: '#fff', fontSize: valFz, fontWeight: 700,
        textAlign: 'center', flexShrink: 0,
      }}>
        x{item.quantidade}
      </div>
      <div style={{
        color: '#fff', fontSize: valFz, fontWeight: 700,
        textAlign: 'right', minWidth: compact ? 72 : 90, flexShrink: 0,
      }}>
        {formatCurrency(item.subtotal)}
      </div>
    </div>
  );
}

function TelaAguardando() {
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 24 }}>
      <span style={{ fontSize: 90, filter: 'drop-shadow(0 4px 16px rgba(230,57,70,0.4))' }}>🥟</span>
      <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 56, margin: 0, fontWeight: 600, letterSpacing: 1, textAlign: 'center' }}>
        Caixa liberado — próximo, por favor!
      </p>
      <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
        {[0, 1, 2].map(i => (
          <div key={i} style={{
            width: 8, height: 8, background: '#e63946', borderRadius: '50%',
            animation: `bounce 1.2s ${i * 0.2}s infinite`,
          }} />
        ))}
      </div>
    </div>
  );
}

function TelaPago() {
  return (
    <div style={{
      flex: 1, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 28,
      background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)',
      animation: 'fadeIn 0.5s ease',
    }}>
      <div style={{
        fontSize: 100, animation: 'popIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        filter: 'drop-shadow(0 0 32px rgba(76,175,80,0.6))',
      }}>✅</div>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ color: '#4caf50', fontSize: 52, margin: 0, fontWeight: 900, letterSpacing: -1 }}>
          Pagamento Confirmado!
        </h1>
      </div>
      <div style={{
        background: 'rgba(76,175,80,0.1)', border: '2px solid rgba(76,175,80,0.3)',
        borderRadius: 20, padding: '24px 48px', textAlign: 'center', maxWidth: 520,
      }}>
        <p style={{ color: '#fff', fontSize: 28, margin: 0, fontWeight: 600, lineHeight: 1.4 }}>
          Obrigado pela sua visita! 😊
        </p>
        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 18, margin: '12px 0 0' }}>
          Foi um prazer te receber aqui na <strong style={{ color: '#e63946' }}>Parada Predileta</strong>.
        </p>
        <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 16, margin: '8px 0 0' }}>
          Volte sempre — sua próxima visita vai ser ainda melhor! 🤩
        </p>
      </div>
      <div style={{ display: 'flex', gap: 12, fontSize: 32, animation: 'slideUp 0.6s 0.3s both' }}>
        {'🥟🥟🥟'.split('').map((e, i) => <span key={i}>{e}</span>)}
      </div>
    </div>
  );
}

export default function Display() {
  const [modo, setModo] = useState('aguardando');
  const [comanda, setComanda] = useState(null);
  const [ultimaAtt, setUltimaAtt] = useState(null);
  const intervalRef = useRef(null);

  const buscar = async () => {
    try {
      const { data } = await api.get('/display/comanda');
      setModo(data.modo || 'aguardando');
      setComanda(data.comanda || null);
      if (data.comanda) setUltimaAtt(new Date());
    } catch {}
  };

  useEffect(() => {
    buscar();
    intervalRef.current = setInterval(buscar, 2000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const total = comanda ? parseFloat(comanda.total) : 0;
  const n = comanda?.itens?.length || 0;
  const layout = calcLayout(n);
  const half = Math.ceil(n / 2);
  const col1 = layout.useColumns ? (comanda?.itens || []).slice(0, half) : (comanda?.itens || []);
  const col2 = layout.useColumns ? (comanda?.itens || []).slice(half) : [];

  return (
    <div style={{
      height: '100vh', background: '#1a1a2e',
      display: 'flex', flexDirection: 'column',
      fontFamily: "'Segoe UI', sans-serif",
      overflow: 'hidden',
    }}>
      {/* Header */}
      <div style={{
        background: modo === 'pago' ? '#2e7d32' : '#e63946',
        padding: '16px 40px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        transition: 'background 0.5s ease',
        flexShrink: 0,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ fontSize: 40 }}>🥟</span>
          <div>
            <h1 style={{ color: '#fff', margin: 0, fontSize: 26, fontWeight: 800 }}>Parada Predileta</h1>
            <p style={{ color: 'rgba(255,255,255,0.8)', margin: 0, fontSize: 13 }}>
              {modo === 'pago' ? 'Pagamento efetuado' : 'Conferência de Pedido'}
            </p>
          </div>
        </div>
        {comanda && modo === 'comanda' && (
          <div style={{ textAlign: 'right' }}>
            <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: 15, fontWeight: 600 }}>
              {comanda.cliente_nome ? `👤 ${comanda.cliente_nome}` : `Comanda #${comanda.numero}`}
            </div>
            {ultimaAtt && (
              <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12, marginTop: 2 }}>
                Atualizado às {ultimaAtt.toLocaleTimeString('pt-BR')}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Conteúdo */}
      <div style={{ flex: 1, padding: '16px 28px', display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0 }}>
        {modo === 'pago' ? (
          <TelaPago />
        ) : modo !== 'comanda' || !comanda ? (
          <TelaAguardando />
        ) : n === 0 ? (
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 22 }}>Nenhum item nesta comanda</p>
          </div>
        ) : (
          <div style={{ display: 'flex', gap: 12, flex: 1, minHeight: 0, overflow: 'hidden' }}>
            {/* Coluna 1 */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: layout.gap, minWidth: 0, overflow: 'hidden' }}>
              <ColHeader />
              {col1.map((item, idx) => (
                <ItemRow key={item.id ?? idx} item={item} layout={layout} />
              ))}
            </div>

            {/* Coluna 2 (quando há itens demais) */}
            {layout.useColumns && col2.length > 0 && (
              <>
                <div style={{ width: 1, background: 'rgba(255,255,255,0.12)', flexShrink: 0 }} />
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: layout.gap, minWidth: 0, overflow: 'hidden' }}>
                  <ColHeader />
                  {col2.map((item, idx) => (
                    <ItemRow key={item.id ?? (half + idx)} item={item} layout={layout} />
                  ))}
                </div>
              </>
            )}
          </div>
        )}
      </div>

      {/* Total */}
      {comanda && modo === 'comanda' && (
        <div style={{
          background: '#e63946', padding: '16px 40px',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          flexShrink: 0,
        }}>
          <span style={{ color: '#fff', fontSize: 20, fontWeight: 600 }}>
            {n} item(ns)
          </span>
          <div style={{ textAlign: 'right' }}>
            <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 13 }}>TOTAL A PAGAR</div>
            <div style={{ color: '#fff', fontSize: 38, fontWeight: 900, lineHeight: 1.1 }}>
              {formatCurrency(total)}
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes bounce {
          0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
          40% { transform: scale(1); opacity: 1; }
        }
        @keyframes popIn {
          0% { transform: scale(0); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
